/** Primitivas de UI compartilhadas pelas abas de Inteligência de Mercado. */
import type { ReactNode } from 'react';

export function Kpi({
  icon, titulo, valor, detalhe,
}: { icon?: ReactNode; titulo: string; valor: string; detalhe?: string }) {
  return (
    <div className="rounded-lg border border-ds-border bg-ds-surface p-4">
      <div className="mb-2 flex items-center gap-1.5 text-xs text-ds-text-secondary">
        {icon}<span>{titulo}</span>
      </div>
      <div className="text-xl font-semibold leading-tight text-ds-text-primary">{valor}</div>
      {detalhe && <div className="mt-1 text-[11px] leading-tight text-ds-text-secondary">{detalhe}</div>}
    </div>
  );
}

export function Painel({ titulo, acao, children }: { titulo: string; acao?: ReactNode; children: ReactNode }) {
  return (
    <div className="rounded-lg border border-ds-border bg-ds-surface p-4">
      <div className="mb-3 flex items-center justify-between gap-2">
        <h3 className="text-sm font-semibold text-ds-text-primary">{titulo}</h3>
        {acao}
      </div>
      {children}
    </div>
  );
}

export function Toggle<T extends string>({ value, options, onChange }: {
  value: T; options: { id: T; label: string }[]; onChange: (v: T) => void;
}) {
  return (
    <div className="flex gap-1 rounded-md border border-ds-border p-0.5">
      {options.map((o) => (
        <button
          key={o.id}
          type="button"
          onClick={() => onChange(o.id)}
          className={
            value === o.id
              ? 'rounded px-2 py-0.5 text-xs font-medium bg-ds-brand-solid text-ds-on-brand'
              : 'rounded px-2 py-0.5 text-xs text-ds-text-secondary hover:bg-ds-surface2'
          }
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}

export function Vazio({ texto }: { texto: string }) {
  return <div className="py-8 text-center text-sm text-ds-text-secondary">{texto}</div>;
}
